/* eslint-disable */
import { assetImages } from "constants";
import React from "react";
import { Link } from "react-router-dom";

// import use translation ------------------------------
import { useTranslation } from "react-i18next";

const SubmitSurveySuccessModal = ({ closeModalHandler }) => {
  const { t } = useTranslation(); // translation marker

  //submit_survey_success_mdl

  return (
    <div
      className="modal fade"
      id="submit_survey_success_mdl"
      tabIndex="-1"
      aria-labelledby="submit_survey_success_mdl"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-body text-center p-5">
            <img
              src={assetImages.congratsImage}
              alt="You saved"
              className="img-fluid mb-2"
            />
            <h2 className="mb-2">{t("Congratulations")}</h2>
            <p className="fs-lg fw-semibold mb-5">
              {t("Survey saved successfuly")}.
            </p>
            <div className="action d-flex justify-content-center gap-3">
              <Link
                to="#"
                data-bs-dismiss="modal"
                className="btn btn-outline-primary"
                onClick={() => {
                  closeModalHandler(true);
                }}
              >
                {t("Close")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubmitSurveySuccessModal;
